// extracted by mini-css-extract-plugin
module.exports = {"container":"J_c","wrapper":"J_bF","wrapper____native":"J_bG","wrapper____overflowy":"J_bH","wrapper__content":"J_bJ","wrapper__scroll":"J_bK","wrapper____overflowy_2":"J_bL"};